import React from "react";
import ProductCard from "./ProductCard";
import { SHOP } from "@/constants/testIds";

export default function ProductGrid({ products = [], title, subtitle, eyebrow, onOpenDetails }) {
  if (!products.length) return null;
  return (
    <section
      data-testid={SHOP.productsSection}
      className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-12 sm:mt-16"
    >
      {(title || eyebrow) && (
        <div className="mb-5 sm:mb-7">
          {eyebrow && (
            <div className="text-[10px] sm:text-xs uppercase tracking-[0.22em] text-[#0056D2] font-bold">
              {eyebrow}
            </div>
          )}
          {title && (
            <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-black text-gray-900 mt-1 tracking-tight">
              {title}
            </h2>
          )}
          {subtitle && <p className="text-sm text-gray-600 mt-2">{subtitle}</p>}
        </div>
      )}

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-5">
        {products.map((p) => (
          <ProductCard key={p.id} product={p} onOpenDetails={onOpenDetails} />
        ))}
      </div>
    </section>
  );
}
